export default function Hero() {
  return (
    <section className="bg-gradient-to-b bg-[#939c32] text-white py-3 sm:py-3 md:py-5">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-1xl sm:text-2xl md:text-2xl font-bold mb-3 sm:mb-4">
          Descubre los mejores destinos en Rumbo Punilla
        </h1>
        <p className="text-sm sm:text-md opacity-90 max-w-2xl mx-auto">
          Encuentra alojamientos únicos, experiencias inolvidables y tours especiales en la región más hermosa de
          Córdoba
        </p>
      </div>
    </section>
  )
}